module.exports = __webpack_public_path__ + "static/media/resume.1923ab2c.pdf";